/** Compteur de modales — évite un overflow body bloqué après fermeture. */
let lockCount = 0;
let savedOverflow = '';

export function lockBodyScroll(): void {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;
}

export function unlockBodyScroll(): void {
  if (typeof document === 'undefined') return;
  if (lockCount <= 0) {
    document.body.style.overflow = '';
    return;
  }
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = savedOverflow;
    savedOverflow = '';
  }
}

/** Nettoyage défensif du scroll body. */
export function clearBodyScrollLock(): void {
  if (typeof document === 'undefined') return;
  lockCount = 0;
  savedOverflow = '';
  document.body.style.overflow = '';
}

export const APP_MODAL_ROOT_ID = 'app-modal-root';

export function getAppModalPortalRoot(): HTMLElement {
  if (typeof document === 'undefined') return document.body;
  return document.getElementById(APP_MODAL_ROOT_ID) ?? document.body;
}

export function getModalPortalTarget(): HTMLElement {
  return getAppModalPortalRoot();
}

/** Vidéos filmstrip hors écran laissées sur document.body après import. */
export function cleanupFilmstripCaptureElements(): void {
  if (typeof document === 'undefined') return;
  document.querySelectorAll('[data-filmstrip-capture]').forEach((el) => {
    el.remove();
  });
}

/**
 * Nettoie scroll lock + vidéos filmstrip.
 * Ne supprime jamais les nœuds modale React ([data-import-trim-modal]) — évite calques fantômes iOS.
 */
export function cleanupOrphanImportLayers(): void {
  if (typeof document === 'undefined') return;
  clearBodyScrollLock();
  cleanupFilmstripCaptureElements();
}

export function purgeStuckModalLayers(): void {
  if (typeof document === 'undefined') return;
  clearBodyScrollLock();
  document.documentElement.classList.remove('mobile-filming-lock');
  purgeStuckImportModals();
  cleanupFilmstripCaptureElements();
}

/** Orphelins / calques empilés après import multi-clips (à appeler quand la file d'import est fermée). */
export function purgeStuckImportModals(): void {
  if (typeof document === 'undefined') return;
  const hadModals = document.querySelectorAll('[data-import-trim-modal]').length > 0;
  document.querySelectorAll('[data-import-trim-modal]').forEach((el) => {
    el.remove();
  });
  if (hadModals) {
    clearBodyScrollLock();
  }
}

/** iOS PWA : le bfcache restaure le DOM avec des backdrops modal — purge au retour app. */
export function installModalLayerGuard(): () => void {
  if (typeof window === 'undefined') return () => {};
  const onPageShow = (event: PageTransitionEvent) => {
    if (!event.persisted) return;
    purgeStuckModalLayers();
  };
  const onVisible = () => {
    if (document.visibilityState !== 'visible') return;
    if (document.body.style.overflow === 'hidden') {
      clearBodyScrollLock();
    }
  };
  window.addEventListener('pageshow', onPageShow);
  document.addEventListener('visibilitychange', onVisible);
  return () => {
    window.removeEventListener('pageshow', onPageShow);
    document.removeEventListener('visibilitychange', onVisible);
  };
}

/** @deprecated Utiliser purgeStuckImportModals */
export function removeLegacyOrphanModals(): void {
  purgeStuckImportModals();
}
